import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { MainRoute, LoginRoute, RouteSheetRoute } from './Routes';
import TranslatorProvider from './Translator';
import configuration from './configuration';

function App() {
  configuration();
  return (
    <TranslatorProvider locale={'bg'}>
      <BrowserRouter>
        <Switch>
          <Route exact path={['/', '/view/:viewName']} component={MainRoute} />
          <Route path='/login' component={LoginRoute} />
          <Route path='/report/route-sheet' component={RouteSheetRoute} />
        </Switch>
      </BrowserRouter>
    </TranslatorProvider>
  );
}

export default App;
